<template>
    <div>
      <!-- {{user.data.otherInfo.bgImg}} -->
      <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
        <div class="home-donations app-bg-gradient">
          <div class="stars-bg"></div>
          <Languages class="languages" v-bind:settings="true"></Languages>
          <Timer></Timer>
          <div class="mosque-name">{{user.data.name}}</div>
          <div class="hint">{{"Please Touch a Donation amount" | translate}}</div>
          <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
          <div class="main-height">
            <div class="amount-select-section">
              <div>
                <div class="donation-aniybt-details cursor" @click="donateAmount(5)">
                  <img src="static/images/5pounds.png" />
                </div>
              </div>
              <div>
                <div class="donation-aniybt-details cursor" @click="donateAmount(10)">
                  <img src="static/images/10pounds.png" />
                </div>
              </div>
              <div>
                <div class="donation-aniybt-details cursor" @click="donateAmount(20)">
                  <img src="static/images/20pounds.png" />
                </div>
              </div>
              <div>
                <div class="donation-aniybt-details cursor" @click="donateAmount(50)">
                  <img src="static/images/50pounds.png" />
                </div>
              </div>
            </div>
          </div>
          <div class="other-donation-option">
            <div class="btn-bg1">
              <div class="btn-bg2">
                <button @click="redirectToChangeAmount()" class="cursor login">{{"Other Amount" | translate}}</button>
              </div>
            </div>
            <div class="btn-bg1">
              <div class="btn-bg2">
                <button @click="back" class="cursor login">{{"Back" | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <!-- <div class="full-screen reports-section app-bg-gradient">
    <Languages class="languages" v-bind:settings="true"></Languages>
    <Timer></Timer>
    <div>
        <div></div>
    </div>
    <div class="choosen d-type in-sentence">{{"Thank you for choosing to donate for" | translate}} <span>{{donationType | translate}}</span>. {{"Please select the amount" | translate}} </div>
    <div class="choosen d-type in-sentence-rearange"><span>{{donationType | translate}}</span> &nbsp;{{"Thank you for choosing to donate for" | translate}}. {{"Please select the amount" | translate}} </div>
    <div class="amount-section">
        <div class="masjid-fund">
            <div class="donation-details" @click="donateAmount(5)">
                <img src="http://i.dailymail.co.uk/i/pix/2013/12/18/article-2525572-1A2EF1C200000578-278_634x316.jpg" />
            </div>
        </div>
        <div class="masjid-fund">
            <div class="donation-details" @click="donateAmount(10)">
                <div>
                    <img src="https://3dwnh01icn0h133s00sokwo1-wpengine.netdna-ssl.com/wp-content/uploads/2016/06/Pound.jpg" />
                </div>
            </div>
        </div>
        <div class="masjid-fund">
            <div class="donation-details" @click="donateAmount(20)">
                <div>
                    <img src="http://us-cash.info/british%20banknote%2020%20pounds%20sterling%20obverse.jpg" />
                </div>
            </div>
        </div>
        <div class="masjid-fund">
            <div class="donation-details" @click="donateAmount(50)">
                <div>
                    <img src="https://www.melloneducate.com/wp-content/uploads/2016/02/%C2%A350.jpg" />
                </div>
            </div>
        </div>
    </div>
    <div class="choosen">
        {{"If you wish to donate a different amount, please enter it here" | translate}}
        <InputField class="amount-field" v-bind:amount="amount" @changedAmount="changedAmount"></InputField>
        <div class="continue" @click="donateAmount(amount)"> {{"Continue" | translate}} &#8250;</div>
    </div>
  </div> -->
</template>
  <!--<input v-model="amount" type="number" pattern="/d*"/>-->

<script>
import { mapGetters, mapActions } from 'vuex'
import InputField from './inputComponent.vue'
import Timer from './timer.vue'
import Languages from './Languages'

export default {
  data () {
    return {
      amount: null,
      donationType: null,
      tid: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'donationAmount'
    ])
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'changeDonationAmount'
    ]),
    redirectToChangeAmount () {
      this.$router.push({path: `/${this.tid}/change-amount/${this.donationType}/0`})
    },
    changedAmount (a) {
      console.log(a)
      this.amount = a
    },
    back () {
      this.$router.go(-1)
    },
    donateAmount (a) {
      if (a !== null && a !== '') {
        // this.changeDonationAmount(+a)
        this.$router.push({path: `/${this.tid}/confirm/${this.donationType}/${a}`})
      } else {
        console.log('select amount')
      }
    }
  },
  components: {
    InputField,
    Timer,
    Languages
  },
  mounted: function () {
    this.donationType = this.$route.params.donationType
    this.tid = this.$route.params.terminalId
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .full-screen {
    background-position: center;
  }
  .home-donations {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
    z-index: 2;
  }
  .bg-img {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    transform: scaleX(-1);
  }
  .mosque-name {
    font-size: 40px;
    color: #FFF;
    font-family: "Lato";
    font-weight: bold;
    text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
    margin-top: 61px;
    margin-bottom: 30px;
    letter-spacing: 2px;
  }
  .hint {
    color: #880913;
    font-size: 22px;
    text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.34 );
    text-transform: uppercase;
    letter-spacing: 2px;
    margin-bottom: 20px;
    font-weight: 600;
  }
  .amount-select-section {
    width: 60%;
    height: calc(100vh - 250px);
    display: flex;
    flex-wrap: wrap;
    z-index: 2;
  }
  .amount-select-section > div {
    width: 50%;
    height: 50%;
    padding: 0 5%;
    display: flex;
    align-items: center;
    justify-content: center;

  }
  .amount-select-section > div > div.donation-aniybt-details {
    width: 100%;
    height: 100%;
  }
  .other-donation-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100px;
  }
  .label {
    color: #FFF;
    font-weight: 18px;
    margin-top: 10px;
    margin-bottom: 10px;
    letter-spacing: 2px;
  }
  .other-donation-option .btn-bg1 {
    margin-top: 0;
    z-index: 2;
    width: 220px;
    height: 74px;
    border-radius: 50px;
    margin-right: 15px;
  }
  .other-donation-option .btn-bg2 {
    width: 210px;
    height: 64px;
    border-radius: 50px;
  }
  .other-donation-option button {
    width: 208px;
    height: 62px;
    border-radius: 50px;
    font-size: 22px;
  }
  .main-height {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 4;
  }
  @media only screen and (min-width: 2000px) {
    .amount-select-section {
      height:50vh !important;
      width:70%;
    }
    .amount-select-section > div {
      padding: 5% 2%;
    }
    .amount-select-section > div .donation-aniybt-details {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .amount-select-section > div .donation-aniybt-details img {
      width: 98%;
      height: 100%;
    }
    .other-donation-option .btn-bg1 {
      margin-top: 0;
      z-index: 2;
      width: 880px !important;
      height: 300px !important;
      border-radius: 200px;
    }
    .other-donation-option .btn-bg2 {
      width: 850px;
      height: 270px;
      border-radius: 200px;
    }
    .other-donation-option button {
      width: 840px;
      height: 260px;
      border-radius: 200px;
      font-size: 80px;
      letter-spacing: 3px;
    }
    .other-donation-option {
      height: auto;
    }
  }

@media screen and (min-width: 1200px) and (min-height: 904px) {
    .main-height {
      height: 65vh;
    }
    .amount-select-section {
      height: 80%;
      width: 70%;
    }
    .amount-select-section > div > div.donation-aniybt-details {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .other-donation-option {
      align-items: flex-start;
      justify-content: flex-start;
      z-index: 5;
    }
    .donation-aniybt-details.cursor img {
      width: 100%;
    }
    .mosque-name {
      margin-bottom: 50px;
    }
    .amount-select-section > div {
      padding: 0 3%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Amount.vue